module.exports = "img/flags/TR.ebdfbab.png";